import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTextInput from '../components/FrTextInput';
import UserOptions from '../components/UserOptions';
import FrSelect from '../components/FrSelect';

import api from '../services/api';
import { getUserCode, getSedeCode } from '../utils/functions';
import { mCPF } from '../utils/masks'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'
import FrTableReg from '../components/FrTable'
import Dialog from '@material-ui/core/Dialog';
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import Clientes from './Clientes'

const swal = withReactContent(Swal)
const moment = require("moment");

function Contratos(props) {
  const [data, setData] = useState({ renova_automatico: 'S', dias: 0 })
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('S')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState('')
  const [dataDep, setDataDep] = useState([{ value: '', display: '', nome: '' }])
  const [dataCad, setDataCad] = useState('')
  const [nomeCli, setNomeCli] = useState('')
  const [pk_cli, setPk_Cli] = useState('')

  const columnsDep = [{ id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 200 },
  { id: 'cpf', numeric: false, label: 'CPF', align: 'left', minWidth: 90 },
  { id: 'nomegrp', numeric: false, label: 'Grau Parentesco', align: 'left', minWidth: 100 },
  { id: 'sexo', numeric: false, label: 'Sexo', align: 'left', minWidth: 50 },
  { id: 'data_nascimento', date: true, numeric: false, label: 'Data Nascimento', align: 'left', minWidth: 100 },
  { id: 'recebeu_carteira', numeric: false, label: 'Recebeu Carteira', align: 'center', minWidth: 50 },
  { id: 'data_cadastro', date: true, numeric: false, label: 'Data Cadastro', align: 'left', minWidth: 100 },
  { id: 'data_cancelado', date: true, numeric: false, label: 'Data Cancelado', align: 'left', minWidth: 100 },
  { id: 'representante', numeric: false, label: 'Representante', align: 'left', minWidth: 200 },
  ]

  const [showModal, setShowModal] = useState(false)
  const [titulo, setTitulo] = useState('')
  const [updateDep, setUpdateDep] = useState(false)
  const [dep, setDep] = useState('')
  const [nome, setNome] = useState('')
  const [cpf, setCpf] = useState('')
  const [sexo, setSexo] = useState('')
  const [data_nascimento, setData_Nascimento] = useState('')
  const [representante, setRepresentante] = useState('')
  const [comboGrp, setComboGrp] = useState([{ value: '', display: '' }])
  const [fk_grp, setFk_Grp] = useState('')
  const [recebeu_carteira, setRecebeu_Carteira] = useState('')
  const [pkModal, setPkModal] = useState(0);
  const [nomegrp, setNomeGrp] = useState('')

  const [showModalCliente, setShowModalCliente] = useState(false)

  useEffect(() => {
    const fetchData = async () => {

      if (props.fk_cli) {
        const auxValues = { ...data };
        auxValues.fk_cli = props.fk_cli
        auxValues.fk_sed = getSedeCode()
        auxValues.fk_emp = props.fk_emp
        api.get('/clientes?pk_cli=' + props.fk_cli).then(async r => {
          setComboCli(await api.getComboDataWhere('clientes', "?nome=" + r.data[0].nome))
          auxValues.cpf = r.data[0].cpf
          auxValues.genero = r.data[0].genero
          auxValues.data_nascimento = r.data[0].data_nascimento
          setData(auxValues)
        })
      }
      setComboGrp(await api.getComboData('grau_parentesco'))

    }

    fetchData()
  }, [])


  useEffect(() => {
    const atualizaCombo = () => {
      if (nomeCli != '')
        setNome(nomeCli)
      if (pk_cli > 0)
        setDep(pk_cli)
    }
    atualizaCombo()
  }, [nomeCli, pk_cli])


  function consistData(data) {
    let required = [
      'fk_cli',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr == 'fk_cli')
        fieldName = 'Titular'

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      title: 'ATENÇÃO',
      text: "Confirma geração do contrato?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          salvarContrato()
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function salvarContrato() {
    const auxValues = { ...data };
    auxValues.dataDep = dataDep
    auxValues.fk_usu = getUserCode()

    api.post('/contratos/addContrato', auxValues).then(r => {
      if (r.status === 200) {
        swal.fire({
          customClass: {
            container: 'my-swal'
          },
          title: 'Registro Adicionado',
          text: "O registro foi adicionado com sucesso!",
          icon: 'success',
        }).then((result) => {
          if (result.value) {
            props.setCto(r.data)
            props.setShowModal(false)
          }
        })
      } else {
        swal.fire({
          customClass: {
            container: 'my-swal'
          },
          title: 'Erro!',
          text: "O registro não foi adicionado!",
          icon: 'warning',
        })
      }
    })
  }


  function handleCancel(e) {
    e.preventDefault();
    props.setShowModalContratos(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      const auxValues = { ...data };
      auxValues.fk_cli = cli

      if (cli > 0) {
        await api.get('/clientes?pk_cli=' + cli).then(r => {
          if (r.data[0]) {
            auxValues.cpf = r.data[0].cpf
            auxValues.data_nascimento = r.data[0].data_nascimento
            auxValues.sexo = r.data[0].genero
            auxValues.fk_ori = r.data[0].fk_ori
            auxValues.fk_sub = r.data[0].fk_sub
            auxValues.nome = r.data[0].nome
            // alert(auxValues.nome)
            setData(auxValues)
          }
        })
      } else
        setData(auxValues)
    }

    fetchData()
  }, [cli])

  useEffect(() => {
    const fetchData = async () => {

      if (dep > 0) {
        await api.get('/clientes?pk_cli=' + dep).then(r => {
          if (r.data[0]) {
            setNome(r.data[0].nome)
            setCpf(r.data[0].cpf)
            setSexo(r.data[0].genero)
            setData_Nascimento(r.data[0].data_nascimento)
            setRepresentante(r.data[0].nomerep)
          }
        })
      }
    }

    fetchData()
  }, [dep])

  useEffect(() => {
    const fetchData = () => {
      if (fk_grp > 0) {
        api.get('/grau_parentesco?pk_grp=' + fk_grp).then(r => {
          if (r.data[0]) {
            setNomeGrp(r.data[0].descricao)
          }
        })
      }
    }

    fetchData()
  }, [fk_grp])

  const handleChange = async (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'fk_cli':
        await api.get('/clientes?pk_cli=' + e.target.value).then(r => {
          if (r.data[0]) {

            auxValues.cpf = r.data[0].cpf
            auxValues.data_nascimento = r.data[0].data_nascimento
            auxValues.sexo = r.data[0].genero
            auxValues.nome = r.data[0].nome
          }
        })
        break

      case 'recebeu_carteira':
        auxValues.recebeu_carteira = auxValues.recebeu_carteira == 'S' ? 'N' : 'S'
        break

      case 'dep_recebeu_carteira':
        setRecebeu_Carteira(recebeu_carteira == 'S' ? 'N' : 'S')
        break

      case 'fk_rep':
        setRepresentante(e.target.value)
        break

      case 'fk_grp':
        setFk_Grp(e.target.value)
        break

      case 'representante':
        setRepresentante(e.target.value)
        break

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  function incluiDep(e) {
    e.preventDefault();
    const dataAtual = new Date();
    const dataFormatada = moment(dataAtual).format('YYYY-MM-DD')

    setTitulo('Inclusão de Dependente')
    setUpdateDep(false)
    setCpf('')
    setSexo('')
    setData_Nascimento('')
    setFk_Grp('')
    setNomeGrp('')
    setRecebeu_Carteira('N')
    setDep('')
    setDataCad(dataFormatada)
    setNome('')
    setRepresentante('')
    setShowModal(true)
  }

  function confirmaDep(e) {
    e.preventDefault();
    if (updateDep)
      editaDep(e)
    else
      insereDep(e)

    setUpdateDep(false)
    setShowModal(false)
  }


  function escondeModal(e) {
    e.preventDefault();
    setShowModal(false)
  }

  function mostraModalCliente(e) {
    e.preventDefault();
    setShowModalCliente(true)
  }

  function insereItem() {
    let pk = dataDep[0].pk ? dataDep.length + 1 : 1
    let item = []

    item.push(
      {
        dep: dep,
        nome: nome,
        cpf: cpf,
        sexo: sexo,
        data_nascimento: data_nascimento,
        representante: representante,
        fk_grp: fk_grp,
        recebeu_carteira: recebeu_carteira,
        nomegrp: nomegrp,
        data_cadastro: dataCad,
        pk: pk
      });

    return item;
  }

  function insereDep(e) {
    e.preventDefault();
    let item = insereItem()
    for (var i = 0; i < dataDep.length; i++) {
      if (dataDep[i].nome !== '')
        item.push({
          dep: dataDep[i].dep,
          nome: dataDep[i].nome,
          cpf: dataDep[i].cpf,
          sexo: dataDep[i].sexo,
          data_nascimento: dataDep[i].data_nascimento,
          representante: dataDep[i].representante,
          fk_grp: dataDep[i].fk_grp,
          recebeu_carteira: dataDep[i].recebeu_carteira,
          pk: dataDep[i].pk,
          nomegrp: dataDep[i].nomegrp,
          data_cadastro: dataDep[i].data_cadastro,
          fk_mot: dataDep[i].fk_mot,
          nomemot: dataDep[i].nomemot,
          data_cancelado: dataDep[i].data_cancelado
        });
    }
    // console.log(item)
    setDataDep(item);
  }


  function editaDep(e) {
    e.preventDefault();

    let item = [];
    let i;
    for (i = 0; i < dataDep.length; i++) {
      if (dataDep[i].pk == pkModal) {
        item.push({
          dep: dep,
          nome: nome,
          cpf: cpf,
          sexo: sexo,
          data_nascimento: data_nascimento,
          representante: representante,
          fk_grp: fk_grp,
          recebeu_carteira: recebeu_carteira,
          nomegrp: nomegrp,
          data_cadastro: dataCad,
          pk: pkModal
        });

      } else {
        item.push({
          dep: dataDep[i].dep,
          nome: dataDep[i].nome,
          cpf: dataDep[i].cpf,
          sexo: dataDep[i].sexo,
          data_nascimento: dataDep[i].data_nascimento,
          representante: dataDep[i].representante,
          fk_grp: dataDep[i].fk_grp,
          recebeu_carteira: dataDep[i].recebeu_carteira,
          pk: dataDep[i].pk,
          formatData: dataDep[i].formatData,
          nomegrp: dataDep[i].nomegrp,
          data_cadastro: dataDep[i].data_cadastro,
          fk_mot: dataDep[i].fk_mot,
          nomemot: dataDep[i].nomemot,
          data_cancelado: dataDep[i].data_cancelado
        });
      }

      if (i + 1 == dataDep.length) setDataDep(item);
    }
  }


  function mostraModalCliente(e) {
    e.preventDefault()
    setShowModalCliente(true)
  }


  return (
    <div className="defaultReg">

      {!props.modal ? <NavBar /> : <></>}

      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Contrato</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrSelect
            value={data.fk_cli || ''}
            onChange={handleChange}
            name="fk_cli"
            id="fk_cli"
            label='Titular'
            data={comboCli}
            style={{ width: 425 }}
            disabled
          />

          <FrTextInput
            value={mCPF(data.cpf) || ''}
            style={{ width: 130 }}
            color="#333333"
            label="CPF"
            variant="outlined"
            size="small"
            disabled
          />

          <FrTextInput
            value={data.sexo || ''}
            style={{ width: 100 }}
            color="#333333"
            label="Sexo"
            variant="outlined"
            size="small"
            disabled
          />
          <FrDatePicker
            value={(data.data_nascimento || '').split('T')[0]}
            color="#49573B"
            label="Dt.Nascimento"
            variant="outlined"
            size="small"
            style={{ width: 130 }}
            noClear
            disabled
          />
          <div className="defaultHeader">
            <h3>Dependentes</h3>
          </div>

          <div className="xButtons">
            <button className="botao" onClick={incluiDep}> {'Incluir'} </button>
          </div>
          <div>
            <br />

            <div className="tableDiv">
              <FrTableReg readOnly={true} rowsPerPage={5} dense editar
                setDep={setDep} setNome={setNome} setRecebeu_Carteira={setRecebeu_Carteira}
                setCpf={setCpf} setSexo={setSexo} setData_Nascimento={setData_Nascimento} setDataCad={setDataCad}
                setRepresentante={setRepresentante} setFk_Grp={setFk_Grp} setPkModal={setPkModal}
                setModal={setShowModal} setUpdateModal={setUpdateDep}
                setDataGrid={setDataDep}
                regName="contratos"
                columns={columnsDep} searched={false} codeName="pk" page={''} data={dataDep} />
            </div>

          </div>


          <div>
            <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
              <div className="defaultHeader">
                <h3>{titulo}</h3>
              </div>
              <div className="modalContent">
                <AutoComp
                  value={nome || ""}
                  valor={dep}
                  width={425}
                  name="dep"
                  id="dep"
                  label='Dependente'
                  data={comboCli}
                  setValue={setDep}
                  tabela={'clientes'}
                  chave={'nome'}
                  autoFocus
                />
                <button className="buttonF2" style={{ height: '30px', width: '35px', borderRadius: '4px' }} onClick={mostraModalCliente}>
                  <Icon icon={ic_search} size={20} />
                </button>


                <br />
                <FrTextInput
                  value={nome || ''}
                  style={{ width: 425 }}
                  name="nome"
                  id="nome"
                  color="#333333"
                  label="Nome"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={100}
                  disabled
                />

                <FrTextInput
                  value={mCPF(cpf) || ''}
                  style={{ width: 130 }}
                  color="#333333"
                  label="CPF"
                  variant="outlined"
                  size="small"
                  disabled
                />

                <FrTextInput
                  value={sexo || ''}
                  style={{ width: 100 }}
                  color="#333333"
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  disabled
                />

                <FrDatePicker
                  value={(data_nascimento || '').split('T')[0]}
                  color="#49573B"
                  label="Dt.Nascimento"
                  variant="outlined"
                  size="small"
                  style={{ width: 130 }}
                  noClear
                  disabled
                />

                <br />

                <FrTextInput
                  value={representante || ''}
                  style={{ width: 300 }}
                  color="#333333"
                  label="Representante"
                  variant="outlined"
                  size="small"
                  maxLength={45}
                  onChange={handleChange}
                  name="representante"
                  id="representante"
                />

                <FrSelect
                  value={fk_grp || ''}
                  onChange={handleChange}
                  name="fk_grp"
                  id="fk_grp"
                  label='Grau de Parentesco'
                  data={comboGrp}
                  style={{ width: 200 }}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name='dep_recebeu_carteira'
                      id='dep_recebeu_carteira'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={recebeu_carteira == 'S'}
                    />
                  }
                  label={'Recebeu Carteira'}
                />

                <div className="FrModalFooter">

                  <div className="FrModalButtonsDiv">

                    <button onClick={confirmaDep}> Confirmar</button>
                    <button onClick={escondeModal}> Sair </button>
                  </div>
                </div>
              </div>
            </Dialog>
          </div>



          <div>
            <Dialog aria-labelledby="simple-dialog-title" open={showModalCliente} fullWidth={true} maxWidth={'lg'}>
              <Clientes modal setShowModalCliente={setShowModalCliente} setNomeCli={setNomeCli} setPk_Cli={setPk_Cli} />
            </Dialog>
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div >
  );
}

export default Contratos;